import apiClient from "./axios";

const BASE_URL = "/vehicle-stock-publishes";

export const getVehicleStockPublishes = async (params = {}) => {
  const response = await apiClient.get(BASE_URL, { params });
  return response.data;
};

export const getVehicleStockPublish = async (id) => {
  const response = await apiClient.get(`${BASE_URL}/${id}`);
  return response.data;
};

export const createVehicleStockPublish = async (data) => {
  const response = await apiClient.post(BASE_URL, data);
  return response.data;
};

export const editVehicleStockPublish = async ({ id, ...data }) => {
  const response = await apiClient.put(`${BASE_URL}/${id}`, data);
  return response.data;
};

export const deleteVehicleStockPublish = async (id) => {
  const response = await apiClient.delete(`${BASE_URL}/${id}`);
  return response.data;
};
